import formPassword from './modules/formPassword';

window.addEventListener('load', formPassword());
